module.exports = __webpack_public_path__ + "files/cad611ca7d3510ffaa0e5c24448ca52e.png";